import { render } from "./MyTasks.vue?vue&type=template&id=7828b2c3"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__